import React from 'react';
import style from './style.scss';
import {MyBusinessAnnouncementContent} from './sub-view/announcement';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessAnnouncementContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <BusinessLayout active='my-business-announcements'>
        <h1 className="user-header">Thông báo</h1>
        <MyBusinessAnnouncementContent/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessAnnouncementContainer;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessAnnouncementContainer.jsx